@if (user) {
  <div class="user-avatar">
    <app-avatar class="avatar-md w-24 flex-none mr-7"
                [url]="user.avatar?.url ?? ''"
                [name]="user.fullName"
    ></app-avatar>
  </div>
  <div class="user-info">
    <h3 class="name" [innerText]="user.fullName"></h3>
    <p class="username" [innerText]=" '@' + user.userName"></p>
  </div>

  <div class="actions">
    @if (!requestSent()) {
      <div (click)="addFriend(user.id)" class="more">
        <app-icon name="heroPlus"></app-icon>
      </div>
    }

    @if (requestSent()) {
      <div class="request-sent">
        Request sent
      </div>
    }
  </div>
}
